class SingleAccordion {
    constructor(element) {
        this.accordion = element;
        this.question = element.querySelector('.js-accordion-question');
        this.answer = element.querySelector('.js-accordion-answer');
        this.activeClass = 'active';

        if (this.question && this.answer) {
            this.init();
        }
    }

    init() {
        this.question.addEventListener('click', () => {
            const isActive = this.accordion.classList.contains(this.activeClass);
            this.answer.style.maxHeight = isActive ? 0 : `${this.answer.scrollHeight + 20}px`;
            this.accordion.classList.toggle(this.activeClass);
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('.lsg-accordion');
    accordions.forEach((accordion) => new SingleAccordion(accordion));
});
